// This function is used to sort an array given a visibility table
function stableSort(array,visibilityTable){
    const stabilizedThis = array.map((el, index) => [el, visibilityTable[index]]);
  
    stabilizedThis.sort((a, b) => {
      
      if(a[1] === true && b[1] === false){
        return 1;
      }
      return -1;
  
    });
    return stabilizedThis.map((el) => el[0]);
  }
  
// This function is used to sort an array given a selected order
function stableSort2(array, comparator) {
    
    const stabilizedThis = array.map((el, index) => [el, index]);
    stabilizedThis.sort((a, b) => {
        const order = comparator(a[0], b[0]);
        if (order !== 0) return order;
        return a[1] - b[1];
    });
    return stabilizedThis.map((el) => el[0]);
}

function convertDateFormat(date){
 
  const newDate = `${date.split('/')[1]}/${date.split('/')[0]}/${date.split('/')[2]}`;
  return newDate;
}


function descendingComparator(a, b, orderBy) {

    if(orderBy === 'date'){
      if( Date.parse( convertDateFormat(b[orderBy].toLowerCase()) ) < Date.parse( convertDateFormat(a[orderBy].toLowerCase())) ) return -1;
      if( Date.parse( convertDateFormat(b[orderBy].toLowerCase()) ) > Date.parse( convertDateFormat(a[orderBy].toLowerCase())) ) return 1;
      return 0;
    }
    if (b[orderBy].toLowerCase() < a[orderBy].toLowerCase()) return -1;
    if (b[orderBy].toLowerCase() > a[orderBy].toLowerCase()) return 1;
    return 0;
    
}

// This function reverts the defined order.
function getComparator(order, orderBy) {
    return order === 'desc'
        ? (a, b) => descendingComparator(a, b, orderBy)
        : (a, b) => -descendingComparator(a, b, orderBy);
}

export {
    stableSort,
    stableSort2,
    getComparator
}